import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../app/store';
import { setEncounterAction as setEncounter } from '../../../../services/EncounterService/slice';
import { EncounterType } from '../../../../services/EncounterService/types/encounterTypes';

const AdmissionTypeEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const encounter = useAppSelector((state) => state.encounter.currentEncounter);

  // Check if encounter is cancelled
  const isEncounterCancelled = encounter?.status === 'CANCEL';

  const admissionTypes = [
    'OP',
    'IP',
    'ER'
  ];

  const handleChange = (value: string) => {
    if (!encounter) return;
    
    const updated = {
      ...encounter,
      encounterInfo: {
        ...encounter.encounterInfo,
        admissionType: value,
      },
    } as EncounterType;
    dispatch(setEncounter(updated));
  };

  return (
    <TextField
      label="Admission Type"
      size="small"
      select
      value={encounter?.encounterInfo?.admissionType || ''}
      onChange={(e) => handleChange(e.target.value)}
      disabled={isEncounterCancelled}
      sx={{ 
        width: '220px',
        '& .MuiInputBase-input': {
          backgroundColor: isEncounterCancelled ? '#f5f5f5' : 'inherit'
        }
      }}
      helperText={isEncounterCancelled ? 'Read-only (Encounter Cancelled)' : ''}
    >
      {admissionTypes.map((type) => (
        <MenuItem key={type} value={type}>{type}</MenuItem>
      ))}
    </TextField>
  );
};

export default AdmissionTypeEdit;
